export default __webpack_public_path__ + "static/media/form4.c2a5ecaf.png";